
import { Component, inject, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { combineLatest, map } from 'rxjs';
import { DrupalService } from '../../services/drupal-service/drupal-service';
import { CountUpDirective } from 'ngx-countup';
import type { CountUpOptions } from 'countup.js';
import { RotatingGallery } from '../rotating-gallery/rotating-gallery';

// Use the global bootstrap object provided by the bundle
declare const bootstrap: any;

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    CountUpDirective,
    RotatingGallery
  ],
  templateUrl: './home.html',
  styleUrls: ['./home.scss'],
})
export class Home implements AfterViewInit {
  private readonly drupalService = inject(DrupalService);
  
  public showYouTube: boolean = false;

  public readonly viewModel$ = combineLatest([
    this.drupalService.getContent('/pillar-3/career-clusters/financial-services'),
  ]).pipe(map(([content]) => ({ content }))); // <-- fixed arrow function

  // ------- COUNTER VALUES -------
  public industryCredentials: number = 77_455;
  public studentsEpso: number = 88;
  public personalizedAdvising: number = 2;        // spelling corrected
  public wblStudents: number = 25;
  public moreAverage: number = 4_200;

  // ------- COUNTER OPTIONS (Scroll Spy enabled) -------
  public indCred: CountUpOptions = {
    duration: 2.5,
    decimalPlaces: 0,        // 77,455 (no decimals); change to 3 if you want .000
    separator: ',',
    enableScrollSpy: true,
    scrollSpyOnce: false,
    scrollSpyDelay: 100,
  };

  public stuEpso: CountUpOptions = {
    duration: 3,
    suffix: '%',
    enableScrollSpy: true,
    scrollSpyOnce: false,
    scrollSpyDelay: 100,
  };

  public persAdv: CountUpOptions = {
    duration: 5,
    suffix: '×',             // nicer multiplication symbol; use 'X' if preferred
    useEasing: true,
    enableScrollSpy: true,
    scrollSpyOnce: false,
    scrollSpyDelay: 100,
  };

  public wblStu: CountUpOptions = {
    duration: 3,
    separator: ',',
    suffix: '%',
    enableScrollSpy: true,
    scrollSpyOnce: false,
    scrollSpyDelay: 100,
  };

  public morAvg: CountUpOptions = {
    duration: 1.6,
    decimalPlaces: 0,        // 4,200%; set to 3 if you want 4,000.000%
    prefix: '$',
    useEasing: true,
    enableScrollSpy: true,
    scrollSpyOnce: false,
       scrollSpyDelay: 100,
  };

  playYouTubeVideo(): void {
    this.showYouTube = true;
  }

  ngAfterViewInit(): void {
    // Attempt to programmatically start the local video on load. Keep muted for autoplay policies.
    setTimeout(() => {
      if (!this.showYouTube) {
        const video = document.querySelector('.videoembed') as HTMLVideoElement | null;
        if (video) {
          try {
            video.muted = true;
            void video.play();
          } catch (e) {
            // play may be blocked; ignore the error
          }
        }
      }
    }, 0);
  }
}